import { gql } from '@apollo/client';

export const CONTRACT_DATA_FRAGMENT = gql`
  fragment ContractData on ContractVersion {
    id
    displayName
    internalName
    contractType
    fileUrl
    hasPersonalization
    scrollRequired
    signatureType
    presignedUrl
    contractId
    version
    stateId
  }
`;

export const FETCH_SIGNUP_CONTRACT_SET = gql`
  ${CONTRACT_DATA_FRAGMENT}

  query Flex_FetchSignupContractSetFromTemplate($signupContractTemplateId: Int!) {
    signupContractSets(id: $signupContractTemplateId) {
      contractSet {
        contracts {
          ...ContractData
        }
      }
    }
  }
`;
